import classnames from 'classnames'

import ContentLoader from 'common/components/contentLoader'

import './badge.scss'

export interface Props {
  children: React.ReactNode,
  className?: string,
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void,
  dataTest?: string,
  isLoading?: boolean
}

const Badge = ({
  children,
  className,
  onClick,
  dataTest,
  isLoading
}: Props) => {
  if (isLoading) {
    return (
      <ContentLoader className={className} width={90} height={26} />
    )
  }

  return (
    <div
      onClick={onClick}
      className={classnames('badge', className, { 'is-cursor-pointer': onClick })}
      data-test={dataTest}>
      {children}
    </div>
  )
}

export default Badge
